/**
 * Constants and URLs for Google Play API
 */

export const URL_BASE = "https://android.clients.google.com";
export const URL_FDFE = `${URL_BASE}/fdfe`;
export const URL_AUTH = `${URL_BASE}/auth`;
export const URL_CHECK_IN = `${URL_BASE}/checkin`;
export const URL_DETAILS = `${URL_FDFE}/details`;
export const URL_DELIVERY = `${URL_FDFE}/delivery`;
export const URL_PURCHASE = `${URL_FDFE}/purchase`;
export const URL_TOC = `${URL_FDFE}/toc`;
export const URL_TOS_ACCEPT = `${URL_FDFE}/acceptTos`;
export const URL_UPLOAD_DEVICE_CONFIG = `${URL_FDFE}/uploadDeviceConfig`;

export const DEFAULT_LOCALE = "en_GB";
export const DEFAULT_TIMEZONE = "America/Mexico_City";
export const DEFAULT_CALLER_SIG = "38918a453d07199354f8b19af05ec6562ced5788";

export const AUTH_SERVICE_URL = "oauth2:https://www.googleapis.com/auth/googleplay";
export const AUTH_APP = "com.google.android.gms";
export const VENDING_APP = "com.android.vending";

export const REQUEST_TIMEOUT_MS = 4000;
